import '@babel/polyfill';

// Required by Axios
import 'es6-promise/auto';
import 'isomorphic-fetch';
import 'intersection-observer';

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';
import { initializeSentry } from 'config/sentry';
import { exposeMomentForIntegrationTests } from 'test/testUtils';

initializeSentry();
exposeMomentForIntegrationTests();

ReactDOM.render(<App />, document.getElementById('app'));
